import { useContext } from 'react'
import { GlobalContext } from 'App'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { secondData } from 'data/second'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/pagination';
import './style.css'

const Second = () => {
  const { isTablet } = useContext(GlobalContext)

  return (
    <div className="bg-black w-full">
      <Swiper
        slidesPerView={1}
        modules={[Pagination]}
        pagination={{
          clickable: true,
        }}>
        {
          secondData.map((item, idx) => (

            idx === 1 ?
              <SwiperSlide
                className='relative overflow-hidden'
                key={idx}>
                <div className="circle-wrapper">
                  <video
                    className={`video`}
                    muted
                    autoPlay
                    loop
                    playsInline
                    controls={isTablet}>
                    <source src="/video/intro.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className='top-0 absolute flex justify-center items-center h-screen' style={{ left: '50%', transform: 'translateX(-50%)' }}>
                  <motion.div
                    className='flex flex-col justify-center items-center gap-5.5 bg-[rgba(0,0,0,0.8)] mb-40 border-1 border-white rounded-full w-[90vw] h-[90vw]'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    <div>
                      {
                        item.title.map((title, index) => (
                          <motion.p
                            key={index}
                            className='font-extrabold text-32 text-white text-center'
                            style={{ textShadow: '0 0 14px black' }}
                            transition={{ delay: 0.3 }}
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY} >
                            {title}
                          </motion.p>
                        ))
                      }
                    </div>
                    <motion.div
                      transition={{ delay: 0.4 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY}
                      className='w-[60vw]'>
                      <p className='text-white text-xs text-center'>{item.content.join(' ')}</p>
                    </motion.div>
                  </motion.div>
                </div>
              </SwiperSlide> :
              <SwiperSlide
                key={idx}
                style={{
                  backgroundImage: `url(${item.imgMo})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  width: '100%',
                  height: '100vh',
                  maxWidth: '2540px',
                  margin: '0 auto'
                }}>
                <div className='flex justify-center items-center h-screen'>
                  <motion.div
                    className='flex flex-col justify-center items-center gap-5.5 bg-[rgba(0,0,0,0.8)] mb-40 border-1 border-white rounded-full w-[90vw] h-[90vw]'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    <div>
                      {
                        item.title.map((title, index) => (
                          <motion.p
                            key={index}
                            className='font-extrabold text-32 text-white text-center'
                            style={{ textShadow: '0 0 14px black' }}
                            transition={{ delay: 0.3 }}
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY} >
                            {title}
                          </motion.p>
                        ))
                      }
                    </div>
                    <motion.div
                      transition={{ delay: 0.4 }}
                      initial={START_ANIMATION_PROPERTY}
                      whileInView={END_ANIMATION_PROPERTY}
                      viewport={VIEWPORT_PROPERTY}
                      className='w-[60vw]'>
                      <p className='text-white text-xs text-center'>{item.content.join(' ')}</p>
                    </motion.div>
                  </motion.div>
                </div>
              </SwiperSlide>

          ))
        }
      </Swiper>
    </div>
  )
}

export default Second
